import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import tripsReducer from "./features/trips/trips.slice";
import authReducer from "./features/auth/auth.slice";
import userReducer from "./features/user/user.slice";
import companySlice from "./features/company/company.slice";
import clientSlice from "./features/client/client.slice";
import clientVehicleSlice from "./features/client/clientVehicle.slice";
import LedgerSlice from "./features/accounts/ledger.slice";

const store = configureStore({
  reducer: {
    trips: tripsReducer,
    auth: authReducer,
    user: userReducer,
    company: companySlice,
    client: clientSlice,
    ledger: LedgerSlice,
    clientVehicle: clientVehicleSlice,
  },
});

setupListeners(store.dispatch);

export default store;
